
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralBoard as ObiBeaconGeneralBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-board.js';
 
 
 

 
 export const ObiBeaconGeneralBoard = createComponent({
   react: React,
   tagName: 'obi-beacon-general-board',
   elementClass: ObiBeaconGeneralBoardElement,
   events: {
     
   }
  });
 
 